import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {ContentStyled} from '../../styles/components/content.style';
import {NavLink} from 'react-router-dom';

export const FacebookLikeStyled = ContentStyled.extend`
  background: ${props => props.theme[props.pageContext].facebookLike.background};
  text-align: center;
  padding: ${props => props.theme[props.pageContext].facebookLike.padding};
  max-width: ${props => props.theme[props.pageContext].facebookLike.maxWidth};
  color: ${props => props.theme[props.pageContext].facebookLike.color};
  ${media.medium`
    max-width: ${props => props.theme[props.pageContext].facebookLike.mobile.maxWidth};
    margin: ${props => props.theme[props.pageContext].facebookLike.mobile.margin};
  `};
`;

export const FaceBookLikeButtonWrppaer = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 1rem;
`;

export const LinkStyled = styled(NavLink)`
  color: ${props => props.theme.homePage.linkColor};
`;



// WEBPACK FOOTER //
// ./components/FacebookLike/FacebookLike.style.js